export default "https://cdn-static.gokick.com/assets/c66ec253f0896645bf734992981ccce4219a90e3/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";